export default "__VITE_ASSET__BOLdaHnb__"